/** @jsxImportSource @emotion/react */
import { Box, List, ListItemButton, ListItemText, Typography, useTheme } from '@mui/material'
import { useLiveContext } from '@app/modules/Live/contexts/Live.Context'
import { LiveLayer } from '../Live.types'
import {
  liveLayersFormContainer,
  liveLayersFormContent,
  liveLayersFormAccordions,
  liveLayerAccordionButton,
  liveLayerOuter,
} from '../styles/LiveLayersForm.styles'
import { MapLayer, MapLayerType } from '@app/types'

type LiveLayersFormProps = {
  onSelectLiveLayer: (feed: LiveLayer) => void
  selectedLive: LiveLayer[]
  onRemoveLayer: (layer: MapLayer, type: MapLayerType) => void
}

export const LiveLayersForm = ({
  onSelectLiveLayer,
  selectedLive,
  onRemoveLayer,
}: LiveLayersFormProps) => {
  const theme = useTheme()
  const { liveLayers } = useLiveContext()

  if (!liveLayers?.length) {
    return (
      <Typography variant="subtitle2" align="center" marginTop={1}>
        No live data feeds available
      </Typography>
    )
  }

  const handleToggleLayer = (feed: LiveLayer) => {
    const isSelected = selectedLive.some((f) => f.id === feed.id)
    if (isSelected) {
      onRemoveLayer(feed, 'live')
    } else {
      onSelectLiveLayer(feed)
    }
  }

  return (
    <Box css={liveLayersFormContainer({ theme })}>
      <Box css={liveLayersFormContent()}>
        <Box css={liveLayersFormAccordions({ theme })}>
          <Box css={liveLayerOuter}>
            <List disablePadding>
              {liveLayers.map((feed) => {
                const selected = selectedLive.find((feedItem) => feedItem.id === feed.id)

                return (
                  <Box key={feed.id}>
                    <ListItemButton
                      key={feed.id}
                      selected={!!selected}
                      css={liveLayerAccordionButton}
                      onClick={() => handleToggleLayer(feed)}
                    >
                      <ListItemText primary={feed.display_name} />
                    </ListItemButton>
                  </Box>
                )
              })}
            </List>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}
